import {
  AmericanExpressCard,
  ApplePayCard,
  GooglePayCard,
  MasterCardIcon,
  VisaCard,
} from 'src/assets';

import { CardIconsWrapper, CardImg, VerticalSeparator } from './styles';

type CardIconOptionsProps = {
  isDigitalAvalible?: boolean;
};
const CardIconOptions: React.FC<CardIconOptionsProps> = ({
  isDigitalAvalible,
}) => {
  return (
    <CardIconsWrapper>
      {isDigitalAvalible && (
        <>
          <CardImg src={ApplePayCard} />
          <VerticalSeparator />
          <CardImg src={GooglePayCard} />
          <VerticalSeparator />
        </>
      )}
      <CardImg src={VisaCard} />

      <VerticalSeparator />
      <CardImg src={MasterCardIcon} />

      <VerticalSeparator />
      <CardImg src={AmericanExpressCard} />
    </CardIconsWrapper>
  );
};

export default CardIconOptions;
